/**
 * Simulation constants. Numbers with a doc reference are BINDING (docs 02/03/
 * 04/12/14); the two marked "dev-team" are engineering/content decisions under
 * doc 13 §B, flagged to the stakeholder in the stage 1 report.
 */

/** Doc 12: fixed timestep 30 Hz, deterministic; rendering interpolates. */
export const TICK_RATE = 30;
export const DT = 1 / TICK_RATE;

/**
 * Doc 03/12: pathing treats a structure tile as `structureHP / referenceDPS`
 * seconds of chewing. The reference value is dev-team: 10 ≈ the DPS of a mid
 * D1 attacker (Gnasher 8, Shellback 12), so a 150 HP wall reads as a 15 s
 * detour-equivalent to the average fish.
 */
export const REFERENCE_DPS = 10;

/** Doc 14: one full rim lap ≈ 90 s. */
export const ORBIT_SECONDS = 90;

/** Doc 14: DOUBLE REEL — pull while a wave is live, +25% on that wave's salvage. */
export const DOUBLE_REEL_BONUS = 0.25;

/**
 * Wages at the whistle (docs 02/04, stakeholder rework 2026-08-24): the
 * economy produces once per ROUND, never per wall-clock second. The capacitor
 * charges per round too: min(chargeRateMax, surplus) × this factor.
 */
export const CAPACITOR_SHIFT_FACTOR = 10;

/** Doc 14: 3 patience pips; at 0 → Riled, +30% HP (+20% Pearls — meta, stage 4). */
export const PATIENCE_PIPS = 3;
export const RILED_HP_MULT = 1.3;

/** Doc 02: building during combat costs +25% ("Panic Tax"). */
export const PANIC_TAX = 0.25;

/** Doc 03: selling refunds 100% in build phases, 50% during combat. */
export const SELL_REFUND_BUILD = 1.0;
export const SELL_REFUND_COMBAT = 0.5;

/** Doc 03: ruin holds the footprint for 1 wave; rebuild from ruin costs 50%. */
export const RUIN_WAVES = 1;
export const RUIN_REBUILD_FACTOR = 0.5;

/** Doc 03: armor is flat reduction per hit; minimum damage per hit is 1. */
export const MIN_DAMAGE = 1;

/**
 * Doc 03: the Core Dome reveals Cloaked fauna within radius 6 — the free
 * answer, and the reason a Cloaked shoal is a positioning problem rather than
 * an equipment check. Splash still lands on the unrevealed, at half.
 */
export const CORE_REVEAL_RADIUS = 6;
export const CLOAK_SPLASH_MULT = 0.5;

/** Doc 04: clear salvage `(20 + 8n)·d`, split 60% ore / 30% alloy / 10% ammo. */
export const SALVAGE_BASE = 20;
export const SALVAGE_PER_N = 8;
export const SALVAGE_SPLIT = { ore: 0.6, alloy: 0.3, ammo: 0.1 } as const;
/** Ore-equivalents (doc 04 chains): 2 ore = 1 alloy, 1 alloy = 2 ammo. */
export const ORE_EQUIV = { ore: 1, alloy: 2, ammo: 1 } as const;

/**
 * Spacing between enemies of one spawn group, seconds. Dev-team pacing knob
 * (shoal timeOffsets are in `src/content/shoals-d1.json`).
 */
export const GROUP_SPACING_S = 0.4;
